import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import Reveal from "@/components/Reveal";
import { IMAGES } from "@/lib/images";
import BusinessEnquiryForm from "@/components/public/BusinessEnquiryForm";

const POINTS = [
  "A practical review of where your business is now",
  "Clear, prioritised next steps — not vague advice",
  "Hands-on help to build the systems and infrastructure",
  "Ongoing or project-based support to suit your stage",
];

export default function Consultation() {
  return (
    <div data-testid="page-consultation" className="bg-bd-black min-h-screen">
      <section className="pt-40 pb-16 grain relative overflow-hidden">
        <img src={IMAGES.lobby} alt="" className="absolute inset-0 w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-gradient-to-t from-bd-black to-bd-black/70" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="overline text-bd-gold mb-6">Request a Consultation</p>
            <h1 className="font-serif text-4xl md:text-7xl text-bd-ivory leading-[1.05] max-w-4xl">
              Discuss your business with the group
            </h1>
            <p className="mt-8 text-base md:text-lg text-bd-ivory/60 max-w-2xl leading-relaxed">
              Whether you're launching, growing or scaling, we combine strategy with practical implementation. Tell us about your business and we'll be in touch to arrange a consultation.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-bd-charcoal">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-4">
            <Reveal>
              <h2 className="font-serif text-3xl text-bd-ivory mb-6">What to expect</h2>
              <div className="space-y-4">
                {POINTS.map((p) => (
                  <div key={p} className="flex items-start gap-3 text-bd-ivory/70 text-sm">
                    <Check size={18} className="text-bd-gold flex-shrink-0 mt-0.5" strokeWidth={2} /> {p}
                  </div>
                ))}
              </div>
              <div className="mt-10 pt-8 border-t border-white/10 text-sm text-bd-ivory/45">
                <p>Prefer to explore our services first?</p>
                <Link to="/services" data-testid="consultation-services-link" className="text-bd-gold hover:text-bd-gold2 transition-colors">View business services →</Link>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <div className="bg-bd-black border border-white/10 p-8 md:p-12">
                <BusinessEnquiryForm />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
